import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import ViewsByProfile from './PeopleGroup/PeopleGroup';
import FilterItems from '../FilterItems/FilterItems';
import PeopleGroup from './PeopleGroup/PeopleGroup';

const GroupInformation = ({
    registrationIdsSelected
}) => {
    const [id, setId] = useState(null);
    const [employeeGroup, setEmployeeGroup] = useState(null);
    const [isActive, setIsActive] = useState('S');
    const [usernameUpdate, setUsernameUpdate] = useState(null);
    const [dtUpdate, setDtUpdate] = useState(false);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [loadingProfilePanel, setLoadingProfilePanel] = useState(null);
    const [groupRecords, setGroupRecords] = useState(null);
    const [attributesDetailProfilePanel, setAttributesDetailItemPanel] = useState(null);
    const [groupsIdsSelected, setGroupIdsSelected] = useState([]);
    const readOnlyAttributes = !(inserting || updating);
    const [isActiveFilter, setIsActiveFilter] = useState('S');

    const attributeList = [
        { name: "id", value: id, setter: setId },
        { name: "employeeGroup", value: employeeGroup, setter: setEmployeeGroup },
        {
            name: "isActive", value: isActive, setter: setIsActive, resetValue: 'S', readOnlyGrid: true,
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        { name: "usernameUpdate", value: usernameUpdate, setter: setUsernameUpdate },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate }
    ];

    useEffect(() => {
        reloadListGroup()
    }, [registrationIdsSelected, isActiveFilter])

    useEffect(() => {
        // A grid é recarregada após salvar (post/put); selecionar uma linha só busca o detalhe
        if ((!groupsIdsSelected || groupsIdsSelected.length != 1) && updating) {
            setUpdating(false)
        }

        if (!groupsIdsSelected || groupsIdsSelected.length > 1) {
            setGroupIdsSelected([])
        }
    }, [groupsIdsSelected, updating]);


    useEffect(() => {
        if (groupsIdsSelected && groupsIdsSelected.length === 1) {
            fetchDataDetail(groupsIdsSelected[0]);
        } else {
            fetchDataDetail(null);
        }
    }, [groupsIdsSelected]);

    useEffect(() => {
        setInserting(false)
        setUpdating(false)
        setGroupIdsSelected([])
    }, [isActiveFilter]);

    const itemPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '86%',
    };

    async function reloadListGroup() {
        const parameters = { isActive: isActiveFilter }
        const groups = await ExecuteAxios.api('get', `/employee-group/grid/`, { params: parameters });
        setGroupRecords(groups);

        if (groups) {
            RemoveIdsNotFound.remove(groups, setGroupIdsSelected, groupsIdsSelected)
        }
    }

    const fetchDataDetail = async (groupsIdsSelected) => {
        const parameters = { id: groupsIdsSelected ? groupsIdsSelected : 0 }
        const item = await ExecuteAxios.api('get', `/employee-group/detail/`, { params: parameters })
        if (item) {
            setAttributesDetailItemPanel(item)
            ApplyAttributes.applyAttributes(item, attributeList)
        }

        if (!groupsIdsSelected || groupsIdsSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    const getItemPanelListOrDetail = () => {
        if (!updating && !inserting) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setGroupIdsSelected}
                    idsSelected={groupsIdsSelected}
                    data={groupRecords}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailProfilePanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function postItem() {
        try {
            setLoadingProfilePanel(true)
            const response = await ExecuteAxios.api('post', `/employee-group/`, {
                employeeGroup: employeeGroup,
                isActive: isActive
            });

            if (response) {
                await reloadListGroup()
            }
            return response;
        } finally {
            setLoadingProfilePanel(false)
        }
    }

    async function putItem() {
        try {
            setLoadingProfilePanel(true)
            const response = await ExecuteAxios.api('put', `/employee-group/`, {
                id: id,
                employeeGroup: employeeGroup,
                isActive: isActive
            });

            if (response) {
                await reloadListGroup()
            }

            return response;
        } finally {
            setLoadingProfilePanel(false)
        }
    }

    return (
        <div style={{
            display: 'flex', flexDirection: 'row', height: '100%', width: '100%'
        }}>
            <div style={{
                display: 'flex', flexDirection: 'column', height: '100%', width: '100%'
            }}
                className={'main-modal two left'}
            >

                <FilterItems
                    isActiveFilter={isActiveFilter}
                    onUpdatesIsActiveFilter={setIsActiveFilter}
                />

                <Panel
                    style={itemPanelStyle}
                    titlePage={'Grupos'}
                    setUpdating={setUpdating}
                    setInserting={setInserting}
                    inserting={inserting}
                    updating={updating}
                    enableEdit={true}
                    canEdit={groupsIdsSelected && groupsIdsSelected.length === 1 && registrationIdsSelected && registrationIdsSelected.length === 1}
                    putFunction={putItem}
                    enableNewRecord={true}
                    canNewRecord={registrationIdsSelected && registrationIdsSelected.length === 1}
                    postFunction={postItem}
                    canViewCRUD={true}
                    readOnly={false}
                    recordsSelected={groupsIdsSelected}
                    viewOnlyOneRecordCRUD={true}
                    resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                    dataListedAttributes={attributesDetailProfilePanel}
                    attributeList={attributeList}
                    onUpdateIdSelected={setGroupIdsSelected}
                >
                    <LoadingIndicator loaded={!loadingProfilePanel}>
                        {getItemPanelListOrDetail()}
                    </LoadingIndicator>
                </Panel>
            </div>
            <PeopleGroup
                groupsIdsSelected={groupsIdsSelected}
            />
        </div>
    );

}
export default GroupInformation;